<template>
  <div>
    <header class="fixed-top align-items-center">
      <div class="container-fluid">
        <div class="row grh-10 align-items-center">
          <div class="col-4">
            <div class="row lh-47">
              <div class="col-auto">
                <span class="btn btn-menu" @click="toggleMenu()">
                   <i class="lni lni-menu mr-0" ></i>
                </span>               
              </div>
              <div class="col d-none d-md-block">
                 <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
                <!-- <div class="search-con ml-lg-5">
                  <div class="row">
                    <div class="col">
                      <input class="form-control search-con-input" />
                    </div>
                    <div class="col-auto">
                      <i class="lni lni-search-alt grmr-7 text-black-50"></i>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>

          <div class="col-8 text-right">


            <!-- User Profile -->
            <div class="float-right lh-47">
              
                <div class="d-inline-block">
                  <b-dropdown
                    class="dropdown-menu-right"
                    right
                    variant="empty"
                    toggle-class="p-0 m-0"
                    menu-class="bg-white "
                    no-caret
                  >
                    <template slot="button-content">
                      <div class="lh-47">
                        <div
                          class="text-body font-weight-600 float-left grmr-7 d-none d-md-block"
                        >
                          {{ user.name }}
                        </div>


                        <div class="profile-pic-con grh-9 grw-9 float-left">
                          <v-lazy-image
                            v-if="user.image"
                            :alt="user.name"
                            :src="user.image.small"
                          />
                        </div>
                      </div>
                    </template>

                    <b-dropdown-item :to="{ name: 'my-account' }">
                      My Account
                    </b-dropdown-item>
                   
                    <b-dropdown-divider />
                    <b-dropdown-item @click="logout">
                      Sign out
                    </b-dropdown-item>
                    <b-dropdown-item @click="logoutAll">
                      Sign out All Devices
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
            </div>

            <!-- Action Icons -->
            <div class="float-right my-auto lh-47">
              <i
                class="lni lni-frame-expand text-black-50 grmr-7 d-none d-lg-inline pointer"
                @click="toggleFullscreen()"
              ></i>

              <i
                class="lni lni-paint-bucket text-black-50 grmr-7 pointer"
                @click="toggleColorMode()"
              ></i>

              <!-- <i class="lni lni-bullhorn text-black-50 grmr-9"></i> -->

              <div class="position-relative d-inline-block grmr-7">               
                <b-dropdown
                  @hide="markNotificationsAsRead()"
                  variant="empty"
                  size="sm"
                  right
                  toggle-class="text-black-50 p-0 m-0"
                  menu-class="position-absolute mt-3 notificationDropdown bg-white"
                  no-caret
                >
                  <template slot="button-content">
                    
                    <i class="lni lni-bullhorn text-black-50 grmr-9  font-size-base" />

                    <span
                      v-if="notifications.filter(x => x.read_at === null).length > 0"
                      class="count blink-me"
                    >
                      {{
                      notifications.filter(x => x.read_at === null).length
                      }}
                    </span>

                    <!-- <span
                      v-if="notifications.filter(x => x.read_at === null).length == 0"
                      class="count bg-success"
                    >
                      <i class="lni lni-checkmark"></i>
                    </span> -->
                  </template>

                  <vue-custom-scrollbar class="p-3" 
                    style="height:320px; width:260px;line-height:1.1"
                  >
                    <b-button
                      :to="{ name: 'notifications' }"
                      variant="primary"
                      size="xs"
                      class="mb-2 btn-block"
                    >
                      View Notifications
                    </b-button>

                    <div
                      class="my-1 pb-1 border-bottom"
                      v-for="notification in notifications"
                      :key="notification.id"
                    >
                      <small class="text-body">
                        {{ notification.data.message }}
                      </small><br>
                      <small class="text-muted py-2">{{ notification.when }}</small>
                    </div>
                  </vue-custom-scrollbar>
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>

        <!-- breadcrumbs on mobile -->
        <!-- <div class="row d-md-none">
          <div class="col">
            <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
          </div>           
        </div> -->
      </div>
    </header>
  </div>
</template>

<script>
import store from "@/store";
import notificationRepo from "./../../api/repos/notificationRepo";
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  components: {
    vueCustomScrollbar
  },
  data() {
    return {
      darkMode: false,
      notifications: [],
       breadcrumbs: []
    };
  },
  mounted() {   
    this.getNotifications();
    window.setInterval(() => {
      this.getNotifications();
    }, 30000);

    this.breadcrumbs = this.$route.meta.breadcrumb;
  },
  methods: {
    toggleFullscreen() {
      if (
        (document.fullScreenElement && document.fullScreenElement !== null) ||
        (!document.mozFullScreen && !document.webkitIsFullScreen)
      ) {
        if (document.documentElement.requestFullScreen) {
          document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
          document.documentElement.webkitRequestFullScreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    toggleColorMode() {
      this.darkMode = !this.darkMode;
      // add/remove class to/from html tag
      let htmlElement = document.documentElement;

      if (this.darkMode) {
        localStorage.setItem("theme", "dark");
        htmlElement.setAttribute("theme", "dark");
      } else {
        localStorage.setItem("theme", "light");
        htmlElement.setAttribute("theme", "light");
      }
    },
    toggleMenu() {
      if (this.$store.getters["menu/menuState"] == "open") {
        store.commit("menu/setMenuState", "close");
      } else {
        store.commit("menu/setMenuState", "open");
      }
    },
    async getNotifications() {
      if (localStorage.getItem("user") !== null) {
        try {
          let { data } = await notificationRepo.notifications();
          this.notifications = data.notifications.data.map(x => {
            return { ...x, when: this.moment(x.created_at).fromNow() };
          });
        } catch (error) {
          console.log(error);
        }
      }
    },

    logout () {
      this.$router.push({ name: 'logout' })
    },

    logoutAll () {
      this.$router.push({ name: 'logoutAll' })
    },

    async markNotificationsAsRead() {
      this.notifications = this.notifications.map(x => {
        return { ...x, read_at: 1 };
      });
      try {
        await notificationRepo.update();
      } catch (error) {
        console.log(error);
      }
    }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    }
  },
  watch: {
    $route() {
      this.breadcrumbs = this.$route.meta.breadcrumb;
    }
  },
};
</script>

<style lang="scss" scoped>
//@import "./../../assets/css/theme_colors";

header {

  border-bottom-left-radius: 44px;
  border-bottom-right-radius: 44px;
  top:0;
  
    
  background-color: var(--bg-white);
  // border-left: solid 3px var(--app-background-color);
  // border-right: solid 3px var(--app-background-color);
  border-bottom: solid 3px var(--app-background-color);

  .profile-pic-con {
    background: var(--container-border);
    border-radius: 40px;
    overflow: hidden;
    img{
     max-height: 110%; 
     max-width: 110%; 
     object-fit: contain;
    }
  }
  .search-con {
    border-radius: 8px;
    max-width: 300px;
    border: none;
    background: var(--container-border);
    line-height: 47px;
  }
  .search-con-input {
    height: 47px;
    margin-left: 5px;
    border: none;
    background: var(--container-border);
  }
  .lh-47 {
    line-height: 47px;
  }
  .count{
    top:-12px;
    left:10px;
    color:white;
    position: absolute;
    background: crimson;
    border-radius: 4px;
    padding: 2px 4px;
    font-size: 9px;
  }

  .btn-menu{
    background: var(--primaryLighter);
    color: #FFF;
    border-radius: 20px;
  }
}
</style>